/* eslint-disable class-methods-use-this */
import { NotificationsApi } from '../api/notifications-api/index.js';
import { Configuration as NotificationsConfiguration } from '../api/notifications-api/runtime.js';
import { APIEndpointPrefixes } from '../constants/api-constants.js';

interface Configuration {
  NotificationApiUrl: string;
  getAuthorizationFn?: () => string;
}

export class ApiClient {
  private configuration: Configuration;

  public noInit = false;

  constructor(configuration: Configuration) {
    this.configuration = configuration;
  }

  get notificationsApi(): NotificationsApi {
    return new NotificationsApi(
      new NotificationsConfiguration({
        basePath: `${this.configuration.NotificationApiUrl}/${APIEndpointPrefixes.Notifications}`,
        headers: {
          Authorization: this.getAuthorization(),
        },
      })
    );
  }

  private getAuthorization(): string {
    return this.configuration.getAuthorizationFn
      ? this.configuration.getAuthorizationFn()
      : '';
  }
}
